import { gql } from '@apollo/client';

export type UserPermissionsMap = { [key: string]: string[] };

export type UserPermission = {
  permissions: UserPermissionsMap;
};

export type UserPermissionResponse = {
  getPermissionsByUserId: UserPermission;
};

export const GET_PERMISSIONS_BY_USER_ID = gql`
  query getPermissionsByUserId($id: ID!) {
    getPermissionsByUserId(id: $id) {
      permissions
    }
  }
`;
